export const AI_SEARCH_FLOW_ID = 'QA Legacy - Document Summary';
export const AI_SEARCH_AGENT_FLOW_ID = 'QA Legacy - Document Search Agent';
export const LUNA_AI_SEARCH_FLOW_ID = 'QA Luna - Document Summary';
export const LUNA_AI_SEARCH_AGENT_FLOW_ID = 'QA Luna - Document Search Agent';
export const AGENT_V2_AI_SEARCH_FLOW_ID = 'Document Search Agent V2 - Gemma';

export const AI_SEARCH_FLOWS = [
  {
    id: AI_SEARCH_FLOW_ID,
    label: 'Current AI Search',
    description: 'Uses the Legacy implementation to search your documents with keyword and semantic search, ' +
      'then builds a cited answer. Supports document status and priority rules.',
    usesKnowledgeBase: false,
  },
  {
    id: AI_SEARCH_AGENT_FLOW_ID,
    label: 'Document Search Agent',
    description: 'Uses the Legacy agent to choose search tools and broaden the search when evidence is ' +
      'insufficient. Supports priority documents.',
    usesKnowledgeBase: false,
  },
  {
    id: AGENT_V2_AI_SEARCH_FLOW_ID,
    label: 'Agent V2 · Gemma',
    description: 'Uses a Gemma agent with compact tool results and the existing document search. Broadens searches ' +
      'when needed and delivers the saved answer without rewriting it.',
    usesKnowledgeBase: false,
  },
  {
    id: 'Knowledge Base - AI Search',
    label: 'Knowledge Base AI Search',
    description: 'Retrieves page evidence from the QA Knowledge Base and uses Mantle Gemma to write a cited answer. ' +
      'Priority document routing is not supported.',
    usesKnowledgeBase: true,
  },
  {
    id: 'kb-agentic-retrieval-flow',
    label: 'KB Agentic Retrieval',
    description: 'Lets Bedrock plan the search, retrieve evidence, and generate the answer. Searches the QA ' +
      'Knowledge Base corpus; priority document routing is not supported.',
    usesKnowledgeBase: true,
  },
  {
    id: 'kb-agentic-retrieval-mantle-flow',
    label: 'KB Agentic Retrieval + Mantle',
    description: 'Uses Bedrock to retrieve evidence and Gemma through Mantle to write the answer. Searches the QA ' +
      'Knowledge Base corpus; priority document routing is not supported.',
    usesKnowledgeBase: true,
  },
] as const;

export const LUNA_AI_SEARCH_FLOWS = [
  {
    id: LUNA_AI_SEARCH_FLOW_ID,
    label: 'Current AI Search · Luna',
    description: 'Uses GPT-6 Luna to summarize keyword and semantic search evidence in a cited answer. ' +
      'Supports document status and priority rules.',
    usesKnowledgeBase: false,
  },
  {
    id: LUNA_AI_SEARCH_AGENT_FLOW_ID,
    label: 'Document Search Agent · Luna',
    description: 'Uses GPT-6 Luna to retrieve evidence and write a cited summary. Supports document status ' +
      'and priority document filters.',
    usesKnowledgeBase: false,
  },
] as const;

export const ALL_AI_SEARCH_FLOWS = [
  AI_SEARCH_FLOWS[0],
  AI_SEARCH_FLOWS[1],
  ...LUNA_AI_SEARCH_FLOWS,
  ...AI_SEARCH_FLOWS.slice(2),
] as const;

export type AISearchFlow = typeof ALL_AI_SEARCH_FLOWS[number];
export type AISearchFlowId = AISearchFlow['id'];

export const getAvailableAISearchFlows = (isLunaEnabled: boolean): readonly AISearchFlow[] => (
  isLunaEnabled ? ALL_AI_SEARCH_FLOWS : AI_SEARCH_FLOWS
);

export const getAISearchFlow = (
  selectedFlowId: AISearchFlowId | null | undefined,
  isSelectorEnabled: boolean,
  isDocumentSearchAgentEnabled: boolean,
  isLunaEnabled = false,
) => {
  const defaultFlow = isLunaEnabled
    ? LUNA_AI_SEARCH_FLOWS[isDocumentSearchAgentEnabled ? 1 : 0]
    : AI_SEARCH_FLOWS[isDocumentSearchAgentEnabled ? 1 : 0];
  return isSelectorEnabled
    ? getAvailableAISearchFlows(isLunaEnabled).find((flow) => flow.id === selectedFlowId) ?? defaultFlow
    : defaultFlow;
};

export const getAISearchIndexName = (
  flow: AISearchFlow,
  isCurrentFlowEnabled: boolean,
): string => {
  if (flow.usesKnowledgeBase) return 'knowledge-base';
  return isCurrentFlowEnabled || flow.id === AGENT_V2_AI_SEARCH_FLOW_ID
    ? 'semantic_search_v2_index'
    : 'semantic_search_index';
};
